import { createApiMutation } from "../../generated-factory";
import { apiClientManager } from "@app/stores/api-manager";
import type { UseCreateBulkRequestsRequest, UseCreateBulkRequestsData, UseCreateRequestRequest, UseCreateRequestData, UseResendRequestRequest, UseResendRequestData } from "@api/@types/consent-request";

export const useCreateBulkRequests = createApiMutation<UseCreateBulkRequestsData, UseCreateBulkRequestsRequest>({
  mutationFn: (req) => apiClientManager.apis.consentRequest.createBulkRequests(req as UseCreateBulkRequestsRequest),
});

export const useCreateRequest = createApiMutation<UseCreateRequestData, UseCreateRequestRequest>({
  mutationFn: (req) => apiClientManager.apis.consentRequest.createRequest(req as UseCreateRequestRequest),
});

export const useResendRequest = createApiMutation<UseResendRequestData, UseResendRequestRequest>({
  mutationFn: (req) => apiClientManager.apis.consentRequest.resendRequest(req as UseResendRequestRequest),
});

export type { UseCreateBulkRequestsRequest, UseCreateBulkRequestsData, UseCreateRequestRequest, UseCreateRequestData, UseResendRequestRequest, UseResendRequestData } from "@api/@types/consent-request";
